import React from 'react';
import styled from 'styled-components';
import { AddIcon, DisablePlusIcon, SubIcon } from '../SvgIcon/CommonSvgIcons';
import RenderChannels from '../../Pages/HomePage/MainContent/RenderChannel';
import RenderChannelRadio from '../RenderChannel/RenderChannelRadio';

const GridChannelWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 12px;
    margin-bottom:20px;
    width:97%;
    min-height: ${(props) => props?.activePlatform == 'Enterprise' ? '315px' : ''};
`;
const FullRowWrapper = styled.div`
  grid-column: 1 / -1; /* spans full width if wrapped in grid */
  display: grid;
  // grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
`;
const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  display: none;
`;
const StyledRadio = styled.span`
  width: 19px;
  height: 19px;
  background:white;
  border: ${(props) =>
        props?.disabled ? '1px solid black' : props?.checked ? '1px solid green' :
    '1px solid black'};
  border-radius: 50%;   // 🔥 circle for radio
  transition: all 150ms;
  position: relative;

  &::after {
    content: '';
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    position: absolute;
    top: 6px;
    left: 6px;
    width: 7px;
    height: 7px;
    background: ${(props) => props?.is_custom ? props?.is_custom : 'green'};
    border-radius: 50%;
  }
`;
const StyledCheckbox = styled.span`
  width: 19px;
  height: 19px;
  background: ${({ checked, disabled }) =>
        disabled ? '#ccc' : checked ? 'green' : '#eee'};
  border: 1px solid #aaa;
  border-radius: 4px;
  transition: all 150ms;
  position: relative;
  margin-bottom:0px !important;

  &::after {
    content: '';
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    position: absolute;
    left: 5px;
    top: 1px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

const ChannelTabWrapper = styled.div`
    width: 220px;
    height: 31px;
    display: grid;
    border: 1px solid rgba(181, 181, 181, 1);
    border-radius: 4px;
    grid-template-columns: 30px 1fr 30px;
    align-items: center;
    padding: 8px;
    align-content: space-evenly;

    & > input {
    
    width:  19px;
    height: 19px;
    }

    & > .addIcon {
      height: 22px;
      width: 25px;
      cursor:pointer;

      & > svg {
      
      height: 22px;
      }

    }

    & > .channelName {
  font-family: inherit;
        font-weight: 600;
        font-size: 14px;
        text-transform: capitalize;
        color:rgba(42, 41, 41, 1);
    }
`;
const ChannelGroupRadio = ({
    personalDetailsData,
    tempTabs,
    handleChange,
    handleSubSectionChange,
    handleChildBoxChecked,
    handleTabClick,
    activeTab,
    tempChannels,
    activePlatform,
    setActivePlatform,
    tempDataVal,
    showEnterprise = true
}) => {
    const handleCloseTab = (title) => {
        setActivePlatform('')
        handleTabClick(title)
    }
console.log(tempDataVal,"tempDataVal");

    return (
        <GridChannelWrapper activePlatform={activePlatform}>
            {tempTabs.map((item) => (
                <div key={item?.title} style={{ gridColumn: 'span 1' }}>
                    <ChannelTabWrapper >
                        {
                            item?.disable == true ?
                                // <CheckboxLabel>
                                    <StyledRadio is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'green'}
           style={{border:'1px solid #c7c7c7'}} checked={item?.isChecked} disabled={item?.disable} />
                                // </CheckboxLabel>
                                :
                                <CheckboxLabel>
                                    <HiddenRadio
                                        
                                        name="channel-group"
                                        checked={item?.isChecked}

                                        onChange={() => handleChange(item)}
                                        disabled={item?.disable}

                                    />
                                    <StyledRadio is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'green'} checked={item?.isChecked} disabled={item?.disable} />
                                </CheckboxLabel>

                        }


                        <div className='channelName'
                            style={{
                                    textAlign: 'justify',
                                    width: '90%',
                                    marginLeft: 'auto',
                                    color: (item?.disable == true)
                                        // (showEnterprise == true && item?.title === 'Enterprise') || (item?.title === 'News & Blogs'))
                                        ? 'rgba(189, 189, 189, 1)'
                                        : 'rgb(42, 41, 41)'
                            }}
                        >{item?.title}</div>
                        {
                            (
                                item?.disable == true
                                // (showEnterprise == true && item?.title === 'Enterprise') || (item?.title === 'News & Blogs')
                            ) ?
                                <div className="addIcon" >{DisablePlusIcon}</div>
                                :
                                activeTab === item?.title ?
                                    <div className="addIcon" onClick={() => handleCloseTab(item?.title)}>{SubIcon}</div>
                                    :
                                    <div className="addIcon" onClick={() => handleTabClick(item?.title)}>{AddIcon}</div>
                        }
                    </ChannelTabWrapper>
                    {activeTab === item?.title && (
                        <FullRowWrapper>
                            <RenderChannelRadio
                                ChannelData={
                                    activeTab == 'Topic' ? tempChannels?.topic :
                                        activeTab == 'Chatter' ? tempChannels?.chatter :
                                            activeTab == 'News & Blogs' ? tempChannels?.news :
                                                tempChannels?.Enterprise

                                }
                                subSectionChecked={handleSubSectionChange}
                                category={item?.title}
                                activePlatform={activePlatform}
                                setActivePlatform={setActivePlatform}
                                data={tempDataVal}
                                handleChildBoxChecked={handleChildBoxChecked}
                                personalDetailsData={personalDetailsData}
                            />
                        </FullRowWrapper>
                    )}
                </div>
            ))}
        </GridChannelWrapper>
    );
};


export default ChannelGroupRadio;